import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'underscore';

export const MenuList = ({
  navClassName,
  className,
  navItemClassName,
  navAnchorClassName,
  items,
  onClick,
}) => {
  const navItems = items.map(({
    title,
    targetId,
  }) => {
    const handleClick = id => (e) => {
      onClick(e, id);
    };

    return (
      <li key={targetId} className={navItemClassName}>
        <a
          href={`#${targetId}`}
          className={navAnchorClassName}
          onClick={handleClick(targetId)}
        >
          {title}
        </a>
      </li>
    );
  });

  return (
    <nav className={navClassName} >
      <ul className={className}>
        {navItems}
      </ul>
    </nav>
  );
};

MenuList.propTypes = {
  navClassName: PropTypes.string,
  className: PropTypes.string.isRequired,
  navItemClassName: PropTypes.string.isRequired,
  navAnchorClassName: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    targetId: PropTypes.string.isRequired,
  })).isRequired,
  onClick: PropTypes.func,
};

MenuList.defaultProps = {
  onClick: noop,
  navClassName: undefined,
};
